module.exports = __webpack_public_path__ + "img/GH-kyujin-design001.2044e37c.webp";